<nav
  class="navbar navbar-vertical navbar-expand-md navbar-light navb"
  id="sidenav-main"
>
  <div class="container-fluid">
    <!-- Toggler -->
    <button
      id="navButton"
      class="navbar-toggler"
      type="button"
      (click)="isCollapsed = !isCollapsed"
      aria-controls="sidenav-collapse-main"
      style="width: auto"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Brand -->
    <a
      class="navbar-brand pt-0"
      routerLinkActive="active"
      [routerLink]="['/dashboard']"
      (click)="toggleMenu()"
    >
      <img
        src="./assets/img/brand/iess_logo.png"
        width="150"
        class="navbar-brand-img"
        alt="..."
      />
    </a>
    <!-- User -->
    <ul class="nav align-items-center d-md-none">
      <!-- <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link nav-link-icon" role="button" ngbDropdownToggle>
          <i class="ni ni-bell-55"></i>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <a class="dropdown-item" href="javascript:void(0)">Action</a>
          <a class="dropdown-item" href="javascript:void(0)">Another action</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)"
            >Something else here</a
          >
        </div>
      </li> -->
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="./assets/img/theme/logou.jpg" />
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bienvenido!</h6>
          </div>
          <a
            routerLinkActive="active"
            [routerLink]="['/perfil']"
            class="dropdown-item"
          >
            <i class="ni ni-single-02"></i>
            <span>Mi Perfil</span>
          </a>
          <div class="dropdown-divider"></div>
          <a (click)="Logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Cerrar sesión</span>
          </a>
        </div>
      </li>
    </ul>
    <!-- Collapse -->
    <div
      class="collapse navbar-collapse"
      [ngbCollapse]="isCollapsed"
      id="sidenav-collapse-main"
    >
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active" [routerLink]="['/dashboard']">
              <img src="./assets/img/brand/iess_logo.png" width="150" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button
              type="button"
              class="navbar-toggler"
              (click)="isCollapsed = !isCollapsed"
            >
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <!-- Form -->
      <form class="mt-4 mb-3 d-md-none">
        <div class="input-group input-group-rounded input-group-merge">
          <input
            type="search"
            class="form-control form-control-rounded form-control-prepended"
            placeholder="Buscar"
            aria-label="Search"
          />
          <div class="input-group-prepend">
            <div class="input-group-text">
              <span class="fa fa-search"></span>
            </div>
          </div>
        </div>
      </form>
      <!-- Navigation -->
      <!--       <ul class="navbar-nav">
          <li *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
              <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link">
                  <i class="ni {{menuItem.icon}}"></i>
                  {{menuItem.title}}
              </a>
          </li>
      </ul> -->
      <!-- Divider -->
      <hr class="my-3" />
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link pr-0" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span
              class="avatar avatar-sm rounded-circle"
              style="background-color: #971b2f"
            >
              <i class="fa fa-user"></i>
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold">{{
                user.username.toUpperCase()
              }}</span>
            </div>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <a (click)="Logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Cerrar sesión</span>
          </a>
        </div>
      </li>
      <!-- Divider -->
      <hr class="my-3" />
      <!-- Heading -->
      <!--       <h6 class="navbar-heading text-muted">Documentation</h6>
 -->
      <!-- Navigation -->
      <ul class="navbar-nav mb-md-3">
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['/dashboard']"
            (click)="toggleMenu()"
          >
            <i class="fa fa-home"></i> Home
          </a>
        </li> -->
        <!-- Boton alumnos -->
        <li class="nav-item" ngbDropdown placement="bottom-right">
          <a
            routerLinkActive="active"
            [routerLink]="['/alumnos/']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-graduation-cap"></i> Alumnos
          </a>
        </li>
        <!-- <li class="nav-item" ngbDropdown placement="bottom-right" #drop="ngbDropdown" (mouseover)='over(drop)'>
          <a
            routerLinkActive="active"
            [routerLink]="['/grupos/']"
            class="nav-link pr-0"
            role="button"
            id="dropdownMenuLink"
            ngbDropdownToggle
          >
            <i class="fa fa-users"></i> Grupos
          </a>
          <div class="dropdown-menu dropdown-menu-right" (mouseout)='out(drop)' aria-labelledby="dropdownMenuLink" ngbDropdownMenu>
            <a
              routerLinkActive="active"
              [routerLink]="['/grupos/todos']"
              class="dropdown-item"
            >
              <i class="fa fa-list"></i>
              <span>Todos los grupos</span>
            </a>
          </div>
        </li> -->

        <!-- Botón Grupos -->
        <li class="nav-item">
          <a
            routerLinkActive="active"
            [routerLink]="['/grupos/']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-users"></i> Grupos
          </a>
        </li>

        <!-- Botón Todos los grupos -->
        <!-- Ocultamos seccion temporalmente hasta corregir el problema de tiempo -->
        <li class="nav-item" *ngIf="false">
          <a
            routerLinkActive="active"
            [routerLink]="['/grupos/todos']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-list"></i> Todos los grupos
          </a>
        </li>

        <!-- Botón Facturación -->
        <li class="nav-item" ngbDropdown placement="bottom-right">
          <a
            routerLinkActive="active"
            [routerLink]="['/facturas/']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-solid fa-file-invoice"></i> Facturación
          </a>
        </li>
        <!-- Botón Registro de Actividades -->
        <li class="nav-item" *ngIf="authService.canViewReports()">
          <a
            routerLinkActive="active"
            [routerLink]="['/registro-actividades/']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-list"></i> Registro de Actividades
          </a>
        </li>
        <!-- Botón Usuarios -->
        <li class="nav-item" *ngIf="authService.canManageUsers()">
          <a
            routerLinkActive="active"
            [routerLink]="['/usuarios/']"
            class="nav-link pr-0"
            role="button"
          >
            <i class="fa fa-list"></i> Usuarios
          </a>
        </li>
        <!-- <li *ngIf="servicios_ver" class="nav-item" ngbDropdown placement="bottom-right">
          <a class="nav-link pr-0" role="button" ngbDropdownToggle>
            <i class="fa fa-globe"></i> Servicios
            <i class="fa fa-angle-down iconmenu" style="padding-left: 48px;"></i>
          </a>
          <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
            <a
              routerLinkActive="active"
              [routerLink]="['/servicios/']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-list"></i>
              <span>Lista</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/servicios/registrar']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fab fa-bitbucket"></i>
              <span>Nuevo Servicio</span>
            </a>
          </div>
        </li>
        <li *ngIf="datos_extras_ver" class="nav-item" ngbDropdown placement="bottom-right">
          <a class="nav-link pr-0" role="button" ngbDropdownToggle>
            <i class="fa fa-database"></i> Datos Extras
            <i class="fa fa-angle-down iconmenu"></i>
          </a>
          <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
            <a
              routerLinkActive="active"
              [routerLink]="['/datos/']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-list"></i>
              <span>Lista</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/datos/registrar']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-folder-plus"></i>
              <span>Nuevo Dato Extra</span>
            </a>
          </div>
        </li>
        <li *ngIf="usuarios_ver" class="nav-item" ngbDropdown placement="bottom-right">
          <a class="nav-link pr-0" role="button" ngbDropdownToggle>
            <i class="fa fa-user-lock"></i> Usuarios
            <i class="fa fa-angle-down iconmenu" style="padding-left: 50px;"></i>
          </a>
          <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
            <a
              routerLinkActive="active"
              [routerLink]="['/usuarios/']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-list"></i>
              <span>Lista</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/usuarios/registrar']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-user"></i>
              <span>Nuevo Usuario</span>
            </a>
          </div>
        </li>

        <li *ngIf="user.id_rol == '1'" class="nav-item" ngbDropdown placement="bottom-right">
          <a class="nav-link pr-0" role="button" ngbDropdownToggle>
            <i class="fa fa-shield-alt"></i> Roles
            <i class="fa fa-angle-down iconmenu" style="padding-left: 71px;"></i>
          </a>
          <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
            <a
              routerLinkActive="active"
              [routerLink]="['/roles/']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-list"></i>
              <span>Lista</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/roles/registrar']"
              class="dropdown-item"
              (click)="toggleMenu()"
            >
              <i class="fa fa-user-shield"></i>
              <span>Nuevo Rol</span>
            </a>
          </div>
        </li> -->
      </ul>
    </div>
  </div>
</nav>
